class Grad
	constructor: (@x, @y, @z) ->
	dot3: (x, y, z) -> @x*x + @y*y + @z*z

fade = (t) -> t*t*t*(t*(t*6 - 15) + 10)

grad3 = [
	new Grad(1, 1, 0), new Grad(-1, 1, 0), new Grad(1, -1, 0), new Grad(-1, -1, 0)
	new Grad(1, 0, 1), new Grad(-1, 0, 1), new Grad(1, 0, -1), new Grad(-1, 0, -1)
	new Grad(0, 1, 1), new Grad(0, -1, 1), new Grad(0, 1, -1), new Grad(0, -1, -1)]

p = [151, 160, 137, 91, 90, 15,
	131, 13, 201, 95, 96, 53, 194, 233, 7, 225, 140, 36, 103, 30, 69, 142, 8, 99, 37, 240, 21, 10, 23,
	190, 6, 148, 247, 120, 234, 75, 0, 26, 197, 62, 94, 252, 219, 203, 117, 35, 11, 32, 57, 177, 33,
	88, 237, 149, 56, 87, 174, 20, 125, 136, 171, 168, 68, 175, 74, 165, 71, 134, 139, 48, 27, 166,
	77, 146, 158, 231, 83, 111, 229, 122, 60, 211, 133, 230, 220, 105, 92, 41, 55, 46, 245, 40, 244,
	102, 143, 54, 65, 25, 63, 161, 1, 216, 80, 73, 209, 76, 132, 187, 208, 89, 18, 169, 200, 196,
	135, 130, 116, 188, 159, 86, 164, 100, 109, 198, 173, 186, 3, 64, 52, 217, 226, 250, 124, 123,
	5, 202, 38, 147, 118, 126, 255, 82, 85, 212, 207, 206, 59, 227, 47, 16, 58, 17, 182, 189, 28, 42,
	223, 183, 170, 213, 119, 248, 152, 2, 44, 154, 163, 70, 221, 153, 101, 155, 167, 43, 172, 9,
	129, 22, 39, 253, 19, 98, 108, 110, 79, 113, 224, 232, 178, 185, 112, 104, 218, 246, 97, 228,
	251, 34, 242, 193, 238, 210, 144, 12, 191, 179, 162, 241, 81, 51, 145, 235, 249, 14, 239, 107,
	49, 192, 214, 31, 181, 199, 106, 157, 184, 84, 204, 176, 115, 121, 50, 45, 127, 4, 150, 254,
	138, 236, 205, 93, 222, 114, 67, 29, 24, 72, 243, 141, 128, 195, 78, 66, 215, 61, 156, 180]

perm = new Array 512
gradP = new Array 512

export default noise =
	seed: (seed) ->
		for i in [0...256]
			v = p[i] ^ (if i & 1 then seed & 255 else seed >> 8 & 255)
			perm[i] = perm[i + 256] = v
			gradP[i] = gradP[i + 256] = grad3[v % 12]
		return

	perlin3: (x, y, z) ->
		# Find unit grid cell containing point
		X = Math.floor x
		Y = Math.floor y
		Z = Math.floor z
		# Get relative xyz coordinates of point within that cell
		x -= X
		y -= Y
		z -= Z
		# Wrap the integer cells at 255 (smaller integer period can be introduced here)
		X &= 255
		Y &= 255
		Z &= 255
		# Calculate noise contributions from each of the eight corners
		n000 = gradP[X     + perm[Y     + perm[Z    ]]].dot3 x, y, z
		n001 = gradP[X     + perm[Y     + perm[Z + 1]]].dot3 x, y, z - 1
		n010 = gradP[X     + perm[Y + 1 + perm[Z    ]]].dot3 x, y - 1, z
		n011 = gradP[X     + perm[Y + 1 + perm[Z + 1]]].dot3 x, y - 1, z - 1
		n100 = gradP[X + 1 + perm[Y     + perm[Z    ]]].dot3 x - 1, y, z
		n101 = gradP[X + 1 + perm[Y     + perm[Z + 1]]].dot3 x - 1, y, z - 1
		n110 = gradP[X + 1 + perm[Y + 1 + perm[Z    ]]].dot3 x - 1, y - 1, z
		n111 = gradP[X + 1 + perm[Y + 1 + perm[Z + 1]]].dot3 x - 1, y - 1, z - 1
		# Compute the fade curve value for x, y, z
		u = fade x
		v = fade y
		w = fade z
		# Interpolate
		Math.lerp(
			Math.lerp(Math.lerp(n000, n100, u), Math.lerp(n001, n101, u), w),
			Math.lerp(Math.lerp(n010, n110, u), Math.lerp(n011, n111, u), w), v)

noise.seed 0



// WEBPACK FOOTER //
// ./client/noise.coffee